module.exports = "query GetSponsor($id: ID!) {\n  sponsor(id: $id) {\n    ...SponsorFragment\n  }\n}\n"